import { API } from "@/lib/api";

const SESSION_KEY = "cit-analytics-session";

function readSessionId() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return "";
    return JSON.parse(raw).id || "";
  } catch {
    return "";
  }
}

/**
 * Fire-and-forget custom analytics event. Used for tracking searches and
 * button clicks. Does not throw — analytics must never break the app.
 */
export function trackEvent(type, meta = {}) {
  const body = JSON.stringify({
    type,
    path: typeof window !== "undefined" ? window.location.pathname : "",
    session_id: readSessionId(),
    referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    meta,
  });
  const url = `${API}/track`;
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(url, blob)) return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (err) {
    console.debug("trackEvent failed", err);
  }
}
